const KIND = { one_on_one: "One-on-one", group: "Group session", donation: "Donation" };
const PAY_STYLE = {
  paid: "text-emerald-300 border-emerald-300/40",
  pending: "text-amber-200 border-amber-200/40",
  cancelled: "text-rose-300 border-rose-300/40",
  expired: "text-rose-300 border-rose-300/40",
  free: "text-sky-200 border-sky-200/40",
  unpaid: "text-sky-200 border-sky-200/40",
};
const PAY_LABEL = { free: "Free", unpaid: "Pay directly" };
const DURATION = { "30": "30 min", "60": "1 hour" };

const Pill = ({ children, className = "", testId }) => (
  <span className={`font-cinzel text-[11px] tracking-widest uppercase border rounded-full px-3 py-1 ${className}`} data-testid={testId}>{children}</span>
);

const Item = ({ label, value }) => value ? (
  <div><p className="field-label !text-[10px]">{label}</p><p className="mt-1 text-sm text-[#f7f1e1]/90 break-words">{value}</p></div>
) : null;

export const BookingRow = ({ b, onStatus }) => (
  <div className="glass rounded-2xl p-6" data-testid={`booking-row-${b.id}`}>
    <div className="flex flex-wrap items-center gap-3">
      <p className="font-cinzel text-lg text-[#f1d57a] mr-auto">{b.name || "Anonymous"}</p>
      <Pill className="text-[#f7f1e1]/80 border-[#d4af37]/30">{KIND[b.kind]}</Pill>
      <Pill className={PAY_STYLE[b.payment_status] || PAY_STYLE.pending} testId={`booking-pay-status-${b.id}`}>{PAY_LABEL[b.payment_status] || b.payment_status}</Pill>
      {(b.amount || b.price) > 0 && <span className="font-display gold-text text-xl">${(b.amount || b.price).toFixed(2)}</span>}
    </div>
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-5">
      <Item label="Email" value={b.email} />
      <Item label="Phone" value={b.phone} />
      <Item label="Service" value={b.service} />
      <Item label="Length" value={DURATION[b.duration]} />
      <Item label="Preferred date" value={b.preferred_date} />
      <Item label="Received" value={new Date(b.created_at).toLocaleString()} />
    </div>
    {b.message && <p className="mt-4 text-sm italic text-[#f7f1e1]/75 border-l border-[#d4af37]/40 pl-4">{b.message}</p>}
    {b.kind !== "donation" && (
      <div className="mt-5 flex items-center gap-3">
        <span className="field-label !text-[10px]">Status</span>
        <select className="field !mt-0 !w-auto !py-1.5 text-sm" value={b.status} onChange={(e) => onStatus(b.id, e.target.value)} data-testid={`booking-status-select-${b.id}`}>
          <option value="new">New</option>
          <option value="confirmed">Confirmed</option>
          <option value="completed">Completed</option>
        </select>
      </div>
    )}
  </div>
);
